import React, { useState, useEffect, useCallback } from "react";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import axios from "axios";
import "../../../assets/css/TopManagementSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const hasImage = (value) =>
  Boolean(
    value && value !== "undefined" && value !== "null" && String(value).trim(),
  );

function formatDate(value) {
  if (!value) return { month: "NEWS", day: "—", year: "" };
  const date = new Date(value);
  if (Number.isNaN(date.getTime()))
    return { month: "NEWS", day: "—", year: "" };
  return {
    month: date.toLocaleString("en", { month: "short" }).toUpperCase(),
    day: date.getDate(),
    year: date.getFullYear(),
  };
}

function TopManagementSection({
  datacontent = [],
  initialPagination,
  id,
  section,
}) {
  const [newsList, setNewsList] = useState(datacontent || []);
  const [activeIndex, setActiveIndex] = useState(0);
  const [page, setPage] = useState(initialPagination?.current_page || 1);
  const [pagination, setPagination] = useState(
    initialPagination || {
      current_page: 1,
      last_page: 1,
      total: 0,
    },
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setNewsList(datacontent || []);
    setActiveIndex(0);
    setPagination(
      initialPagination || { current_page: 1, last_page: 1, total: 0 },
    );
  }, [datacontent, initialPagination]);

  const fetchNews = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(`${BASE_URL}posdata`, {
        params: {
          "pageName[eq]": id,
          "columes[eq]": "title_show_echo_01",
          "ministry[eq]": 0,
          "status02[eq]": "publish",
          "status[eq]": "Public",
          "visibility[eq]": "Public",
          "display01[eq]": 2,
          page,
          per_page: 10,
        },
      });
      const items = response?.data?.allData || [];
      setNewsList(items);
      setActiveIndex(0);
      setPagination(
        response?.data?.pagination || {
          current_page: page,
          last_page: 1,
          total: items.length,
        },
      );
    } catch (err) {
      console.error("Unable to load ministry information:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [id, page]);
console.log("###333", newsList);
  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const changePage = (nextPage) => {
    const last = Math.max(1, Number(pagination?.last_page || 1));
    if (nextPage >= 1 && nextPage <= last && nextPage !== page)
      setPage(nextPage);
  };
  const toggleItem = (index) =>
    setActiveIndex((current) => (current === index ? null : index));

  if (!newsList.length && !loading && !error) return null;

  return (
    <section id="TopManagement" className="fmw-top-management">
      <div className="container">
        <header className="fmw-tm-heading">
          <div>
            <span className="fmw-tm-eyebrow">FEDERAL MINISTRY OF WORKS</span>
            <h2>{section}</h2>
            {/* <p>Explore key announcements, information and ministry updates.</p> */}
          </div>
          <span className="fmw-tm-mark" aria-hidden="true">
            FMW <b>•</b>
          </span>
        </header>

        {loading && (
          <div className="fmw-tm-status" role="status">
            <span className="fmw-tm-spinner" /> Loading ministry information…
          </div>
        )}
        {error && (
          <div className="fmw-tm-error" role="alert">
            We could not load this information. Please try again.{" "}
            <button type="button" onClick={fetchNews}>
              Try again
            </button>
          </div>
        )}

        {!!newsList.length && (
          <div className="fmw-tm-list">
            {newsList.map((item, index) => {
              const open = activeIndex === index;
              const date = formatDate(item.daterqw);
              const title = item.title || "Ministry information";
              return (
                <article
                  className={`fmw-tm-item ${open ? "is-active" : ""}`}
                  key={item.id || item.trackerf || `${title}-${index}`}
                >
                  <button
                    type="button"
                    className="fmw-tm-trigger"
                    aria-expanded={open}
                    onClick={() => toggleItem(index)}
                  >
                    <span className="fmw-tm-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="fmw-tm-trigger-text">
                      <span className="fmw-tm-date">
                        {date.month} {date.day}, {date.year}
                      </span>
                      <span className="fmw-tm-title">{title}</span>
                    </span>
                    <span className="fmw-tm-chevron" aria-hidden="true">
                      {open ? "−" : "+"}
                    </span>
                  </button>
                  {open && (
                    <div className="fmw-tm-content">
                      {hasImage(item.passport) && (
                        <div className="fmw-tm-image-wrap">
                          <img
                            loading="lazy"
                            decoding="async"
                            src={`${BACKEND_URL}upload/${item.passport}`}
                            alt={title}
                            className="fmw-tm-image"
                          />
                        </div>
                      )}
                      <div className="fmw-tm-body">
                        <div className="fmw-tm-story-title">
                          <HTMLDisplay html={item.story01} type="title" />
                        </div>
                        <div className="fmw-tm-story">
                          <HTMLDisplay html={item.story01} type="body" />
                        </div>
                      </div>
                    </div>
                  )}
                </article>
              );
            })}
          </div>
        )}

        {Number(pagination?.last_page || 1) > 1 && (
          <nav
            className="fmw-tm-pagination"
            aria-label="Ministry information pagination"
          >
            <span>
              Page <strong>{pagination?.current_page || page}</strong> of{" "}
              <strong>{pagination?.last_page || 1}</strong>
            </span>
            <div className="fmw-tm-page-buttons">
              <button
                type="button"
                onClick={() => changePage(1)}
                disabled={page <= 1 || loading}
                aria-label="First page"
              >
                «
              </button>
              <button
                type="button"
                onClick={() => changePage(page - 1)}
                disabled={page <= 1 || loading}
                aria-label="Previous page"
              >
                ‹
              </button>
              <button
                type="button"
                onClick={() => changePage(page + 1)}
                disabled={page >= Number(pagination?.last_page || 1) || loading}
                aria-label="Next page"
              >
                ›
              </button>
              <button
                type="button"
                onClick={() => changePage(Number(pagination?.last_page || 1))}
                disabled={page >= Number(pagination?.last_page || 1) || loading}
                aria-label="Last page"
              >
                »
              </button>
            </div>
          </nav>
        )}
      </div>
    </section>
  );
}

export default React.memo(TopManagementSection);
